<template>
  <div class="option-trade-container">
    <!-- 期权交易表单 -->
    <div class="option-form flex">
      <!-- 买涨表单 -->
      <div class="left-form">
        <div class="time-box flex-wrap">
          <div class="time flex-center green"  v-for="(item, i) in timeList" :key="i" @click="changeUpDownPercent(item)" :class="[upDownForm.time == item.Time ? 'active' : '']">
            {{item.Time}}S {{parseFloat(item.ProfitRatio)}}%
          </div>
        </div>

        <div class="form-label">{{ $t('gou-mai-jin-e') }}</div>
        <div class="trade-money ">
          <input type="number" inputmode="decimal" v-model="upDownForm.money" :placeholder="futuresObj ? `${i18n.t('trade.label73')} ${futuresObj.MinInvestment} USDT` : i18n.t('trade.label74')">
          <div class="flex-center icon">
            USDT
          </div>
        </div>
        <div class="form-label">{{i18n.t('trade.label35')}}：{{profitMoney}} USDT</div>
        <div class="form-label">
          <span>{{i18n.t('trade.label34')}}：</span>
          <span v-if="!hideBalance">{{parseFloat(userOptionMoney).toFixed(4)}} USDT</span>
          <span v-else>**** USDT</span>
          <Icon 
            :name="hideBalance ? 'eye-o' : 'eye'" 
            size="14" 
            color="#85898F" 
            @click="toggleBalance"
            class="balance-toggle ml-5"
          />
        </div>
        <div class="flex-center-between bottom-submit-btn" v-if="isLogin">
          <Button class="btn green" @click="submit(false)">{{i18n.t('trade.buy3')}}</Button>
        </div>
        <div class="flex-center-between bottom-submit-btn" v-if="!isLogin">
          <Button class="btn gray" @click.stop="toLogin">
            <span class="blue">{{i18n.t('login.title')}}</span>
            {{ $t('huo') }}	<span class="blue">{{i18n.t('register.btn4')}}</span>
          </Button>
        </div>
      </div>

      <!-- 买跌表单 -->
      <div class="right-form">
        <div class="time-box flex-wrap">
          <div class="time flex-center red"  v-for="(item, i) in timeList" :key="i" @click="changeUpDownPercent(item, true)" :class="[upDownForm.time2 == item.Time ? 'active' : '']">
            {{item.Time}}S {{parseFloat(item.ProfitRatio)}}%
          </div>
        </div>

        <div class="form-label">{{ $t('gou-mai-jin-e-0') }}</div>
        <div class="trade-money ">
          <input type="number" inputmode="decimal" v-model="upDownForm.money2" :placeholder="futuresObj2 ? `${i18n.t('trade.label73')} ${futuresObj2.MinInvestment} USDT` : i18n.t('trade.label74')">
          <div class="flex-center icon">
            USDT
          </div>
        </div>
        <div class="form-label">{{i18n.t('trade.label35')}}：{{profitMoney2}} USDT</div>
        <div class="form-label">
          <span>{{i18n.t('trade.label34')}}：</span>
          <span v-if="!hideBalance">{{parseFloat(userOptionMoney).toFixed(4)}} USDT</span>
          <span v-else>**** USDT</span>
          <Icon 
            :name="hideBalance ? 'eye-o' : 'eye'" 
            size="14" 
            color="#85898F" 
            @click="toggleBalance"
            class="balance-toggle ml-5"
          />
        </div>
        <div class="flex-center-between bottom-submit-btn" v-if="isLogin">
          <Button class="btn red" @click="submit(true)">{{i18n.t('trade.sell3')}}</Button>
        </div>
        <div class="flex-center-between bottom-submit-btn" v-if="!isLogin">
          <Button class="btn gray" @click.stop="toLogin">
            <span class="blue">{{i18n.t('login.title')}}</span>
            {{ $t('huo') }}
            <span class="blue">{{i18n.t('register.btn4')}}</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Icon } from 'vant';

export default {
  name: 'OptionTrade',
  components: {
    Button,
    Icon
  },
  props: {
    bitInfo: {
      type: Object,
      default: () => ({})
    },
    tabIndex: {
      type: Number,
      default: 2
    },
    pageType: {
      type: Number,
      default: 1
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    userOptionMoney: {
      type: [String, Number],
      default: '0.0000'
    },
    timeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      upDownForm: {
        time: '',
        percent: '',
        money: '',
        time2: '',
        percent2: '',
        money2: '',
      },
      futuresObj: {},
      futuresObj2: {},
      hideBalance: true
    }
  },
  computed: {
    profitMoney() {
      if (!this.upDownForm.money) {
        return '0.0000'
      } else {
        return (this.upDownForm.money * this.upDownForm.percent / 100).toFixed(4)
      }
    },
    profitMoney2() {
      if (!this.upDownForm.money2) {
        return '0.0000'
      } else {
        return (this.upDownForm.money2 * this.upDownForm.percent2 / 100).toFixed(4)
      }
    }
  },
  watch: {
    timeList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          let data = newVal[0]
          if (data) {
            this.futuresObj = data
            this.upDownForm.time = data.Time
            this.upDownForm.percent = data.ProfitRatio

            this.futuresObj2 = data
            this.upDownForm.time2 = data.Time
            this.upDownForm.percent2 = data.ProfitRatio
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    changeUpDownPercent(data, isSale) {
      if (isSale) {
        this.futuresObj2 = data
        this.upDownForm.time2 = data.Time
        this.upDownForm.percent2 = data.ProfitRatio
      } else {
        this.futuresObj = data
        this.upDownForm.time = data.Time
        this.upDownForm.percent = data.ProfitRatio
      }
    },
    submit(isSale) {
      this.$emit('submit-option', {
        isSale,
        upDownForm: this.upDownForm,
        futuresObj: isSale ? this.futuresObj2 : this.futuresObj,
        profitMoney: isSale ? this.profitMoney2 : this.profitMoney
      })
    },
    toLogin() {
      this.$emit('to-login')
    },
    toggleBalance() {
      this.hideBalance = !this.hideBalance
    }
  }
}
</script>

<style scoped>
.balance-section {
  align-items: center;
}

.balance-toggle {
  cursor: pointer;
  margin-left: 5px;
  transition: opacity 0.2s;
}

.balance-toggle:hover {
  opacity: 0.7;
}

.ml-5 {
  margin-left: 5px;
}
</style> 